import { Button } from '../components/ui/Button';

const NotFoundPage = () => {
    return (
        <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4">
            <div className="bg-apple-50 w-24 h-24 rounded-full flex items-center justify-center mb-8">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-12 h-12 text-apple-500"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
                    />
                </svg>
            </div>

            <h1 className="text-4xl font-semibold text-apple-800 mb-3">404</h1>
            <h2 className="text-2xl font-semibold text-apple-800 mb-5">Страница не найдена</h2>

            <p className="text-apple-500 max-w-md mb-8">
                Запрашиваемая страница не существует или была удалена.
                Возможно, вы перешли по устаревшей ссылке или допустили опечатку в адресе.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
                <Button
                    variant="primary"
                    size="lg"
                    to="/"
                >
                    На главную
                </Button>

                <Button
                    variant="secondary"
                    size="lg"
                    to="/equipment"
                >
                    К списку оборудования
                </Button>
            </div>
        </div>
    );
};

export default NotFoundPage;
